import stls from '@f_ucs/styles/components/report/violationStatisticsModule/purchaseReport/reportTable/reportTable.module.sass';
import { useContext } from 'react';
import { ThemeContext } from '@f_context/Theme_context';

export function ColumnAvarageBill ({ suitItemsLength, price, index }:any, idRow:any, isOpenDetails:any)  {
    const { colors } = useContext(ThemeContext);

    return (
        <div
            style={
                suitItemsLength
                    ? {
                        border: `0.5px solid ${colors.lambda}`,
                        background: 'rgba(235, 66, 66, 0.2)',
                        color:
                            idRow !== index && isOpenDetails
                                ? colors.blurColor
                                : colors.omicron,
                    }
                    : {}
            }
            className={stls.cellPrice}>
            {suitItemsLength
                ? price.toFixed(2) + ' ₽'
                : ''}
        </div>
    )
}